export default __webpack_public_path__ + "population-800-0019ee12dc64356fad7f5b6ffb403058.webp";